<template>
  <div class="image-slot">
    <img v-if="src" :src="src" :alt="alt" loading="lazy">
    <span v-else class="fallback" :style="{ background: tint }" aria-hidden="true">{{ initials }}</span>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  src: { type: String, default: '' },
  alt: { type: String, default: '' },
  // Used to derive initials and a tint when there is no image yet.
  label: { type: String, default: '' },
  tint: { type: String, default: 'var(--tint-1)' }
})

const initials = computed(() => props.label
  .split(/\s+/)
  .filter(Boolean)
  .map((word) => Array.from(word)[0])
  .join('')
  .slice(0, 2))
</script>

<style scoped>
.image-slot {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.fallback {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: var(--font-display);
  font-size: clamp(48px, 8vw, 96px);
  font-weight: 300;
  color: var(--ink);
  opacity: 0.85;
}
</style>
